import React, { useState } from 'react';
import { Card, Typography } from 'antd';
import PaymentForm from '../../features/payment/components/PaymentForm';
import PaymentProgress from '../../features/payment/components/PaymentProgress';
import PaymentResult from '../../features/payment/components/PaymentResult';
import PaymentFailure from '../../features/payment/components/PaymentFailure';
import { PaymentResult as PaymentResultType, PaymentError } from '../../features/payment/hooks/usePayment';

const { Title, Text } = Typography;

type PaymentStep = 'form' | 'progress' | 'result' | 'failure';

const PaymentPage: React.FC = () => {
  const [step, setStep] = useState<PaymentStep>('form');
  const [paymentData, setPaymentData] = useState<{
    onayId: string;
    amount?: number;
  } | null>(null);
  const [result, setResult] = useState<PaymentResultType | null>(null);
  const [errorData, setErrorData] = useState<PaymentError | null>(null);

  const handlePaymentSubmit = (onayId: string, amount?: number) => {
    setPaymentData({ onayId, amount });
    setStep('progress');
  };

  const handlePaymentSuccess = (paymentResult: PaymentResultType) => {
    setResult(paymentResult);
    setStep('result');
  };

  const handlePaymentError = (error: PaymentError) => {
    setErrorData(error);
    setStep('failure');
  };

  const handleNewPayment = () => {
    setStep('form');
    setPaymentData(null);
    setResult(null);
    setErrorData(null);
  };

  const handleRetry = () => {
    setStep('form');
    setErrorData(null);
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        padding: '16px',
      }}
    >
      {step === 'form' && (
        <Card
          style={{
            width: '100%',
            maxWidth: 500,
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
          }}
        >
          <Title level={2} style={{ textAlign: 'center', marginBottom: 24 }}>
            Пополнение Onay
          </Title>

          <PaymentForm
            onSubmit={handlePaymentSubmit}
            onSuccess={handlePaymentSuccess}
            onError={handlePaymentError}
          />

          <div style={{ marginTop: 24, textAlign: 'center' }}>
            <Text type="secondary" style={{ fontSize: '12px' }}>
              Введите Onay ID вручную или отсканируйте штрихкод
            </Text>
          </div>
        </Card>
      )}

      {step === 'progress' && paymentData && (
        <PaymentProgress
          onayId={paymentData.onayId}
          amount={paymentData.amount}
        />
      )}

      {step === 'result' && result && (
        <PaymentResult
          transactionId={result.transactionId}
          account={result.account}
          amount={result.amount}
          phone={result.phone}
          promo={result.promo}
          onNewPayment={handleNewPayment}
        />
      )}

      {step === 'failure' && errorData && (
        <PaymentFailure
          transactionId={errorData.transactionId}
          code={errorData.code}
          messages={errorData.messages}
          messageCodes={errorData.messageCodes}
          account={errorData.account}
          amount={errorData.amount}
          phone={errorData.phone}
          promo={errorData.promo}
          onRetry={handleRetry}
          onCancel={handleNewPayment}
        />
      )}
    </div>
  );
};

export default PaymentPage;
